import _ from 'lodash'
import Backbone from 'backbone'
import projects from 'scoreboard/projects/projects'
import { registerPushNotificationListenersForUser } from 'scoreboard/setup-push-notifications'

class ProjectUpdates {

	/**
	 * Listens to websocket events for the project tree.
	 * Should only be invoked after the tree is loaded.
	 */
	listenToTree(gardener) {
		this.on('delete', id => this._delete(id, gardener))
	}

	_delete(deletedId, gardener) {
		const tree = gardener.tree
		tree.removeNode(deletedId)
		if (deletedId == projects.id) {
			projects.id = projects.firstProjectId()
		}
	}
}

_.extend(ProjectUpdates.prototype, Backbone.Events)
const projectUpdates = new ProjectUpdates()

const topics = _.map(['delete'], event => {
	return { topic: `/projects/${event}`, onReceive: data => projectUpdates.trigger(event, data) }
})
registerPushNotificationListenersForUser(topics)

export default projectUpdates
projectUpdates.__filename__ = 'projects/project-updates.js'
